import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable, Subscribable, SubscribableOrNullableValue } from 'knockout';
import DragAndDropFilesManager from 'managers/dragAndDrop/files';
import { EffectsContainer } from 'mixins/withEffects';
import './droparea.html';
import './droparea.scss';

export class DropAreaModel {
    file: Observable<File | undefined> = ko.observable();

    constructor() { }
}

export interface DropAreaVMConfig {
    disabled?: SubscribableOrNullableValue<boolean>
    onDrop?: Action<[File]>
}

@injectable()
export default class DropAreaVM {
    active: Subscribable<boolean>
    inactive: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) configOrModel: DropAreaModel | DropAreaVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        let onDrop: Action<[File]>
        let isDisabled: SubscribableOrNullableValue<boolean>

        if (configOrModel instanceof DropAreaModel) {
            onDrop = file => configOrModel.file(file)
        } else {
            onDrop = configOrModel.onDrop ?? _.noop;
            isDisabled = configOrModel.disabled;
        }

        const manager = effects.register(new DragAndDropFilesManager({
            element: info.element as HTMLElement,
            disabled: isDisabled,
            onDrop: files => _(files).each(file => onDrop(file))
        }));

        this.active = manager.active;
        this.inactive = this.active.not();

        ko.applyBindingsToNode(info.element, {
            'css': {
                'active': this.active
            }
        });
    }
}